module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-list-item', [_c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.collaborator.name))])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.collaborator.role))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.collaborator.email))])]), _vm._v(" "), (_vm.editable) ? _c('md-list-expand', [_c('md-button', {
    on: {
      "click": _vm.removeCollaborator
    }
  }, [_c('md-icon', [_vm._v("delete")]), _vm._v("\r\n            Remove\r\n        ")], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-708656ce","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/collaborators/pending-collaborator.vue
// module id = 661
// module chunks = 2